import React from "react";
import styled from "styled-components";
//import tw from 'tailwind.macro';
import tw from "twin.macro";
import { useStaticQuery, graphql, Link } from "gatsby";

//import { Title, Dot, Text } from '../../styles/GlobalStyles';

import { GatsbyImage } from "gatsby-plugin-image";

import Thermana from "../../images/thermana1.jpg";
// import Slika6 from '../../images/slika6.jpg';
// import Slika7 from '../../images/slika7.jpg';
import { FaUserPlus, FaPenNib, FaHome } from "react-icons/fa";

const HeroImage = styled.div`
  ${tw`h-full w-full bg-cover`}
  background-image: url(${Thermana});
`;

const Hero2 = () => {
  const data = useStaticQuery(graphql`
    {
      logo: file(relativePath: { eq: "DV2022-L-Teal.png" }) {
        childImageSharp {
          gatsbyImageData(
            height: 400
            quality: 100
            placeholder: BLURRED
            layout: FULL_WIDTH
          )
        }
      }
      slika6: file(relativePath: { eq: "slika6.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            height: 400
            quality: 100
            placeholder: BLURRED
            layout: FULL_WIDTH
          )
        }
      }
      slika7: file(relativePath: { eq: "slika7.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            height: 400
            quality: 100
            placeholder: BLURRED
            layout: FULL_WIDTH
          )
        }
      }
    }
  `);
  console.log(data);

  return (
    <div>
      <div className="bg-teal-600 md:overflow-hidden">
        <div className="px-4 py-20 md:py-4">
          <div className="md:mx-auto md:max-w-6xl">
            <div className="md:flex md:flex-wrap">
              <div className="text-center md:w-1/2 md:pt-16 md:text-left">
                <h1 className="font-inter mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-100 sm:text-6xl lg:text-7xl">
                  Dnevi varstvoslovja<span className="text-teal-400">.</span>
                </h1>

                <p className="font-inter mb-2 text-lg font-medium text-gray-200 sm:text-2xl ">
                  Konferenčni center Thermana Laško, 8. in 9. junija 2022.
                </p>
                {/* <p className="text-gray-200 text-lg sm:text-2xl font-medium font-inter mb-2 ">
                  Konferenca bo potekala v konferenčnih dvoranah{' '}
                  <a href="https://www.thermana.si/kongresi" className="text-dv2021-200 underline">
                    Kongresnega centra Thermana Laško
                  </a>
                  , 9. in 10. junija 2021.
                </p> */}

                <div className="mt-16 flex justify-center sm:justify-start">
                  <Link
                    to="/"
                    className="mr-2 block rounded-lg bg-teal-900 px-2 py-2 text-lg font-medium text-gray-200 hover:scale-125 hover:bg-teal-500 sm:text-2xl md:px-4"
                  >
                    <FaHome className="mr-1 -mt-2 inline-block" />
                  </Link>
                  {/* <Link
                    to="/prijavnica/"
                    className="block rounded-lg bg-teal-800 px-2 py-2 text-lg font-medium text-gray-200 hover:scale-125 hover:bg-teal-500 sm:text-2xl md:px-4"
                  >
                    <FaUserPlus className="mr-2 -mt-2 hidden sm:inline-block" />
                    Prijavi se
                  </Link>
                  <Link
                    to="/povzetek/"
                    className="mx-2 block rounded-lg bg-teal-700 px-2 py-2 text-lg font-medium text-gray-200 hover:scale-125 hover:bg-teal-500 sm:text-2xl md:px-4"
                  >
                    <FaPenNib className="mr-2 -mt-2 hidden sm:inline-block" />
                    Oddaj povzetek
                  </Link> */}
                </div>
              </div>
              {/* <div className="md:w-1/2 relative"> */}
              <div className="relative md:w-1/2">
                <div className="hidden md:block">
                  <div className="absolute left-0 bottom-0 z-20 -ml-12 -mb-36 w-80 -rotate-6 transform rounded-lg bg-white px-6 py-8 shadow-lg">
                    <GatsbyImage
                      image={data.logo.childImageSharp.gatsbyImageData}
                      className="max-w-md"
                    />
                    {/* <div className="bg-indigo-800 mx-auto rounded-lg px-2 pb-2 relative mb-8">
                      <div className="mb-1">
                        <span className="w-1 h-1 bg-indigo-100 rounded-full inline-block mr-0.5"></span>
                        <span className="w-1 h-1 bg-indigo-100 rounded-full inline-block mr-0.5"></span>
                        <span className="w-1 h-1 bg-indigo-100 rounded-full inline-block"></span>
                      </div>
                      <div className="h-1 w-12 bg-indigo-100 rounded mb-1"></div>
                      <div className="h-1 w-10 bg-indigo-100 rounded mb-2"></div>

                      <div className="flex">
                        <div className="w-6 h-3 rounded bg-indigo-100 mr-1"></div>
                        <div className="w-6 h-3 rounded bg-indigo-100"></div>
                      </div>

                      <div className="-mr-2 -mb-4 absolute bottom-0 right-0 h-16 w-10 rounded-lg bg-green-700 border-2 border-white"></div>
                      <div className="w-2 h-2 rounded-full bg-green-800 mx-auto absolute bottom-0 right-0 mr-2 -mb-2 z-10 border-2 border-white"></div>
                    </div>

                    <div className="text-gray-800 text-center">
                      Online <br />
                      Services
                    </div> */}
                  </div>

                  <div className="absolute left-0 bottom-0 z-30 ml-16 mb-20 w-72 -rotate-6 transform rounded-lg bg-white shadow-lg">
                    <GatsbyImage
                      image={data.slika6.childImageSharp.gatsbyImageData}
                      className="block h-full w-full max-w-lg rounded-lg object-cover object-center"
                    />
                  </div>

                  {/* <div
                    className="ml-32 absolute left-0 bottom-0 w-48 bg-white rounded-lg shadow-lg px-10 py-8 -rotate-6 z-10"
                    style={{ marginBottom: -220 + 'px' }}>
                    <div className="bg-indigo-800 mx-auto rounded-lg pt-4 mb-16 relative">
                      <div className="h-4 bg-white"></div>

                      <div className="text-right my-2 pb-1">
                        <div className="inline-flex w-3 h-3 rounded-full bg-white -mr-2"></div>
                        <div className="inline-flex w-3 h-3 rounded-full bg-indigo-800 border-2 border-white mr-2"></div>
                      </div>

                      <div className="-ml-4 -mb-6 absolute left-0 bottom-0 w-16 bg-green-700 mx-auto rounded-lg pb-2 pt-3">
                        <div className="h-2 bg-white mb-2"></div>
                        <div className="h-2 bg-white w-6 ml-auto rounded mr-2"></div>
                      </div>
                    </div>

                    <div className="text-gray-800 text-center">
                      Payment for <br />
                      Internet
                    </div>
                  </div> */}

                  <HeroImage
                    className="absolute right-0 top-0 z-10 mt-36 flex w-full -rotate-6 transform overflow-hidden rounded-lg bg-white shadow-lg"
                    style={{ marginRight: -250 + "px" }}
                  ></HeroImage>

                  {/* <div
                    className="w-full absolute left-0 bottom-0 ml-1 -rotate-6 z-10"
                    style={{ marginBottom: -360 + 'px' }}>
                    <div className="grid--gray h-48 w-48"></div>
                  </div> */}
                </div>

                {/* <div className="md:hidden w-full absolute right-0 top-0 flex rounded-lg bg-white overflow-hidden shadow">
                  <div className="h-4 bg-gray-200 absolute top-0 left-0 right-0 rounded-t-lg flex items-center">
                    <span className="h-2 w-2 rounded-full bg-red-500 inline-block mr-1 ml-2"></span>
                    <span className="h-2 w-2 rounded-full bg-orange-400 inline-block mr-1"></span>
                    <span className="h-2 w-2 rounded-full bg-green-500 inline-block mr-1"></span>
                  </div>
                  <div className="w-32 bg-gray-100 px-2 py-8" style={{ Height: 340 + 'px' }}>
                    <div className="h-2 w-16 bg-gray-300 rounded-full mb-4"></div>
                    <div className="flex items-center mb-4">
                      <div className="h-5 w-5 rounded-full bg-gray-300 mr-3 flex-shrink-0"></div>
                      <div>
                        <div className="h-2 w-10 bg-gray-300 rounded-full"></div>
                      </div>
                    </div>

                    <div className="h-2 w-16 bg-gray-200 rounded-full mb-2"></div>
                    <div className="h-2 w-10 bg-gray-200 rounded-full mb-2"></div>
                    <div className="h-2 w-20 bg-gray-200 rounded-full mb-2"></div>
                    <div className="h-2 w-6 bg-gray-200 rounded-full mb-2"></div>
                    <div className="h-2 w-16 bg-gray-200 rounded-full mb-2"></div>
                    <div className="h-2 w-10 bg-gray-200 rounded-full mb-2"></div>
                    <div className="h-2 w-20 bg-gray-200 rounded-full mb-2"></div>
                    <div className="h-2 w-6 bg-gray-200 rounded-full mb-2"></div>
                  </div>
                  <div className="flex-1 px-4 py-8">
                    <h2 className="text-xs text-gray-700 font-bold mb-1">Popular Payments</h2>
                    <div className="flex mb-5">
                      <div className="p-2 w-12 rounded-full bg-gray-100 mr-2"></div>
                      <div className="p-2 w-12 rounded-full bg-gray-100 mr-2"></div>
                      <div className="p-2 w-12 rounded-full bg-gray-100 mr-2"></div>
                      <div className="p-2 w-12 rounded-full bg-gray-100 mr-2"></div>
                    </div>

                    <div className="flex flex-wrap -mx-2 mb-5">
                      <div className="w-1/3 px-2">
                        <div className="p-3 rounded-lg bg-white shadow">
                          <div className="w-6 h-6 rounded-full bg-gray-200 mb-2"></div>
                          <div className="h-2 w-10 bg-gray-200 mb-1 rounded-full"></div>
                          <div className="h-2 w-6 bg-gray-200 rounded-full"></div>
                        </div>
                      </div>
                      <div className="w-1/3 px-2">
                        <div className="p-3 rounded-lg bg-white shadow">
                          <div className="w-6 h-6 rounded-full bg-gray-200 mb-2"></div>
                          <div className="h-2 w-10 bg-gray-200 mb-1 rounded-full"></div>
                          <div className="h-2 w-6 bg-gray-200 rounded-full"></div>
                        </div>
                      </div>
                      <div className="w-1/3 px-2">
                        <div className="p-3 rounded-lg bg-white shadow">
                          <div className="w-6 h-6 rounded-full bg-gray-200 mb-2"></div>
                          <div className="h-2 w-10 bg-gray-200 mb-1 rounded-full"></div>
                          <div className="h-2 w-6 bg-gray-200 rounded-full"></div>
                        </div>
                      </div>
                    </div>

                    <h2 className="text-xs text-gray-700 font-bold mb-1">Popular Payments</h2>

                    <div className="w-full flex flex-wrap justify-between items-center border-b-2 border-gray-100 py-3">
                      <div className="w-1/3">
                        <div className="flex">
                          <div className="h-5 w-5 rounded-full bg-gray-200 mr-3 flex-shrink-0"></div>
                          <div>
                            <div className="h-2 w-16 bg-gray-200 mb-1 rounded-full"></div>
                            <div className="h-2 w-10 bg-gray-100 rounded-full"></div>
                          </div>
                        </div>
                      </div>
                      <div className="w-1/3">
                        <div className="w-16 rounded-full bg-green-100 py-2 px-4 mx-auto">
                          <div className="p-1 rounded-full bg-green-200"></div>
                        </div>
                      </div>
                      <div className="w-1/3">
                        <div className="h-2 w-10 bg-gray-100 rounded-full mx-auto"></div>
                      </div>
                    </div>

                    <div className="flex flex-wrap justify-between items-center py-3">
                      <div className="w-1/3">
                        <div className="flex">
                          <div className="h-5 w-5 rounded-full bg-gray-200 mr-3 flex-shrink-0"></div>
                          <div>
                            <div className="h-2 w-16 bg-gray-200 mb-1 rounded-full"></div>
                            <div className="h-2 w-10 bg-gray-100 rounded-full"></div>
                          </div>
                        </div>
                      </div>
                      <div className="w-1/3">
                        <div className="w-16 rounded-full bg-orange-100 py-2 px-4 mx-auto">
                          <div className="p-1 rounded-full bg-orange-200"></div>
                        </div>
                      </div>
                      <div className="w-1/3">
                        <div className="h-2 w-16 bg-gray-100 rounded-full mx-auto"></div>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* <div
                  className="mr-3 md:hidden absolute right-0 bottom-0 w-40 bg-white rounded-lg shadow-lg px-10 py-6 z-10"
                  style={{ marginBottom: -380 + 'px' }}>
                  <div className="bg-indigo-800 mx-auto rounded-lg w-20 pt-3 mb-12 relative">
                    <div className="h-3 bg-white"></div>

                    <div className="text-right my-2">
                      <div className="inline-flex w-3 h-3 rounded-full bg-white -mr-2"></div>
                      <div className="inline-flex w-3 h-3 rounded-full bg-indigo-800 border-2 border-white mr-2"></div>
                    </div>

                    <div className="-ml-4 -mb-6 absolute left-0 bottom-0 w-16 bg-green-700 mx-auto rounded-lg pb-2 pt-3">
                      <div className="h-2 bg-white mb-2"></div>
                      <div className="h-2 bg-white w-6 ml-auto rounded mr-2"></div>
                    </div>
                  </div>

                  <div className="text-gray-800 text-center text-sm">
                    Payment for <br />
                    Internet
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <svg
          className="hidden fill-current text-teal-50 md:block"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
        >
          <path fillOpacity="1" d="M0,224L1440,32L1440,320L0,320Z"></path>
        </svg>
      </div>
    </div>
  );
};

export default Hero2;
